import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { smevCheckApplicationFailed, smevCheckApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* smevCheckApplication(action) {
  try {
    const { checkId } = action.payload;
    const url = `${BACKEND_URL}/resources/checks/${checkId}/run`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(smevCheckApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield dataResponse.json();
      yield put(smevCheckApplicationFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(smevCheckApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
